module.exports = __webpack_public_path__ + "static/media/kitty-cat_zoom.021c443d.png";